import {ConfirmationDialog, DetailPane, FormDialog} from '@management-ui/core';
import AddIcon from '@mui/icons-material/Add';
import {Link} from '@mui/material';
import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {ServiceContext} from '../../../../components/Services';
import AssociateProductForm from '../../forms/AssociateProductForm';

const Associations = ({product, onLoading}) => {
  const services = useContext(ServiceContext);
  const loaded = useRef(0);
  const [associations, setAssociations] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showNew, setShowNew] = useState(false);
  const [showRemove, setShowRemove] = useState(false);

  useEffect(() => {
    if (loaded.current !== product.id) {
      loaded.current = product.id;
      services.product.getAssociations(product).then((list) => {
        onLoading(false);
        setAssociations(list);
      }).catch(() => onLoading(false));
    }
  }, [services, product, onLoading]);

  const handleSaved = useCallback((updated) => {
    setShowNew(false);
    setAssociations(updated);
    setSelected(null);
  }, []);

  const handleRemove = useCallback(confirmed => {
    setShowRemove(false)
    if (confirmed) {
      onLoading(true);
      services.product.associate(product, selected.id).then((updated) => {
        onLoading(false);
        handleSaved(updated);
      }).catch(() => onLoading(false));
    }
  }, [services, product, onLoading, selected, handleSaved])

  return (
    <DetailPane
      title="Associated Products"
      details={associations.map(association => ({
        title: '',
        value: (
          <Link
            onClick={() => setSelected(association) || setShowRemove(true)}
            disabled={product.archived}
            color="secondary"
            underline="hover"
          >{association.name}</Link>
        )
      }))}
      actions={product.archived ? [] : [
        {title: 'Associate Product', icon: <AddIcon/>, onClick: () => setShowNew(true)},
      ]}
      dialogs={[
        (props) => (
          <FormDialog
            {...props}
            title="Associate Product"
            open={showNew}
            onClose={() => setShowNew(false)}
            maxWidth="sm"
            render={(props) => (
              <AssociateProductForm
                {...props}
                association={{}}
                product={product}
                existing={associations}
                onSaved={handleSaved}/>
            )}
          />
        ),
        (props) => (
          <ConfirmationDialog
            {...props}
            open={showRemove}
            title="Remove Association"
            message={selected ? `Are you sure you want to remove the association with ${selected.name}?` : ''}
            onClose={handleRemove}
          />
        )
      ]}
    />
  )
};

export default Associations;
